/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Restore_DoneInputs */



/**
* | output |
* | --- |
* | "Project restored to the checkpoint." |
*
* @param {Assistant_Restore_DoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_restore_done = /** @type {((inputs?: Assistant_Restore_DoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Restore_DoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Projet restauré au point de contrôle.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt auf den Kontrollpunkt zurückgesetzt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Progetto ripristinato al checkpoint.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект возобновился на контрольно-пропускном пункте.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El proyecto ha regresado al punto de control.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目已恢复到检查点。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトはチェックポイントまで復旧しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट को चेकपॉइंट पर वापस लाया गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto retomado ao ponto de controle.")
	return /** @type {LocalizedString} */ ("Project restored to the checkpoint.")
});